import {resizeMediaByWidth} from '@wix/wixstores-client-core';
import {AttributesModel} from '../models/LineItems/Attributes.model';

type MediaDimensions = {width: number; height: number};

export const getImageDimensions = (
  image: AttributesModel['image'],
  defaultDimensions: MediaDimensions
): MediaDimensions => {
  if (!image?.width || !image.height) {
    return defaultDimensions;
  }

  return resizeMediaByWidth(image, defaultDimensions.width);
};
